import axios from "axios";
import { COOKIES } from "@/constants/cookies";
import { parseCookies } from "nookies";

export const apiBookingManager = axios.create({
  baseURL: import.meta.env.VITE_BOOKING_MANAGER,
  headers: {
    "auth-token": parseCookies()[COOKIES.BACKOFFICE_AUTH],
    Authorization: `Bearer ${parseCookies()[COOKIES.BACKOFFICE_AUTH]}`,
  },
});

apiBookingManager.interceptors.request.use((config) => {
  const authCookie = parseCookies()[COOKIES.BACKOFFICE_AUTH];

  if (authCookie) {
    config.headers["auth-token"] = authCookie;
    config.headers["Authorization"] = `Bearer ${authCookie}`;
  }

  return config;
});
